import { createAction, props } from '@ngrx/store';
import { LogAnalysisDetails } from '../../../model/log-analysis/log-analysis';

export const loadLogAnalysis = createAction(
  `[Log Analysis] Trigger loading of AI Log Analysis for pipeline run from backend`,
  props<{ pipelineRunId: number }>(),
);

export const setLogAnalysisResult = createAction(
  `[Log Analysis] Set AI Log Analysis for pipeline run from backend in store`,
  props<{ pipelineRunId: number; aiLogAnalysis: LogAnalysisDetails[] }>(),
);

export const loadLogAnalysisError = createAction(
  `[Log Analysis] Loading of AI Log Analysis for pipeline run from backend error`,
  props<{ pipelineRunId: number }>(),
);

export const loadLogAnalysisTemporaryError = createAction(
  `[Log Analysis] Loading of AI Log Analysis for pipeline run from backend temporary error`,
  props<{ pipelineRunId: number }>(),
);

export const loadLogAnalysisNotFound = createAction(
  `[Log Analysis] Loading of AI Log Analysis for pipeline run from backend not found`,
  props<{ pipelineRunId: number }>(),
);
